'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Drawer, Heading } from '@petsmart-ui/sparky';
import { useEffect, useId, useState } from 'react';
import { FormProvider, useWatch } from 'react-hook-form';
import { useStore } from '@libs/common-next';
import { CartConfirmDrawer, useCartConfirmDrawer } from '../CartConfirmDrawer';
import { CurbsideInfoDetail } from '../CurbsideInfoDetail';
import { PDPStoreDrawer } from '../pdp-store-drawer';
import { MiniPdpProductInfo } from './mini-pdp-product-info';
import { MiniPdpPurchaseForm } from './mini-pdp-purchase-form';
import { MiniPdpSkeleton } from './mini-pdp-skeleton';
import { useMiniPdpForm } from './model/use-mini-pdp-form';
import { useMiniPdpDrawer } from './model/useMiniPdpDrawer';
import { useMiniPdpProduct } from './model/useMiniPdpProduct';
import type { MiniPdpDrawerProps } from './types';
import './MiniPdpDrawer.scss';
export function MiniPdpDrawer(t0) {
  const $ = _c(71);
  const {
    className,
    onFindStoreClick,
    onAddToCartClick,
    onSameDayDeliveryClick
  } = t0;
  const isOpen = useMiniPdpDrawer(_temp);
  const close = useMiniPdpDrawer(_temp2);
  const openCartDrawerWith = useCartConfirmDrawer(_temp3);
  const {
    base,
    tailored,
    isLoading,
    isError
  } = useMiniPdpProduct();
  const {
    selectedStore
  } = useStore();
  const defaultProduct = base?.variants[base.defaultSku];
  const form = useMiniPdpForm(defaultProduct, base?.defaultSku);
  let t1;
  if ($[0] !== form.control) {
    t1 = {
      control: form.control,
      name: "selectedSku"
    };
    $[0] = form.control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedSku = useWatch(t1);
  const resolvedSku = base?.variants[selectedSku] ? selectedSku : base?.defaultSku;
  const selectedProduct = resolvedSku && base ? base.variants[resolvedSku] : undefined;
  const [isStoreDrawerOpen, setIsStoreDrawerOpen] = useState(false);
  const selectedStoreName = selectedStore.data?.Name;
  const headingId = useId();
  const [hasBeenRendered, setHasBeenRendered] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setHasBeenRendered(true);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const t4 = !isOpen;
  let t5;
  if ($[4] !== close || $[5] !== t4) {
    t5 = <CartConfirmDrawer stacked={true} forceClosed={t4} onCloseAll={close} />;
    $[4] = close;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const cartConfirmDrawer = t5;
  if (!hasBeenRendered) {
    return cartConfirmDrawer;
  }
  let t6;
  if ($[7] !== onAddToCartClick || $[8] !== openCartDrawerWith || $[9] !== resolvedSku || $[10] !== selectedProduct) {
    t6 = () => {
      onAddToCartClick?.();
      const firstMedia = selectedProduct?.media[0];
      let image;
      if (firstMedia?.type === "image") {
        image = firstMedia.url;
      } else {
        if (firstMedia?.type === "video") {
          image = firstMedia.poster;
        }
      }
      openCartDrawerWith(selectedProduct && resolvedSku ? [{
        sku: resolvedSku,
        name: selectedProduct.name,
        image
      }] : [], {}, {
        stacked: true
      });
    };
    $[7] = onAddToCartClick;
    $[8] = openCartDrawerWith;
    $[9] = resolvedSku;
    $[10] = selectedProduct;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleAddToCartClick = t6;
  const t7 = className ? `mini-pdp-drawer ${className}` : "mini-pdp-drawer";
  let t8;
  if ($[12] !== headingId) {
    t8 = <Drawer.Header className="mini-pdp-drawer__header"><Heading id={headingId} tagName="h2" size="headline" data-testid="mini-pdp-drawer-title">Choose Options</Heading></Drawer.Header>;
    $[12] = headingId;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = base ? "true" : "false";
  const t10 = tailored ? "true" : "false";
  let t11;
  if ($[14] !== isError || $[15] !== isLoading || $[16] !== selectedProduct) {
    t11 = isLoading && !selectedProduct && !isError && <MiniPdpSkeleton />;
    $[14] = isError;
    $[15] = isLoading;
    $[16] = selectedProduct;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== isError || $[19] !== selectedProduct) {
    t12 = isError && !selectedProduct && <p data-testid="mini-pdp-error">Unable to load product</p>;
    $[18] = isError;
    $[19] = selectedProduct;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== base || $[22] !== isLoading || $[23] !== selectedProduct || $[24] !== tailored) {
    t13 = selectedProduct && <div className="mini-pdp-drawer__options"><MiniPdpProductInfo product={selectedProduct} /><MiniPdpPurchaseForm base={base} product={selectedProduct} tailored={tailored} isLoading={isLoading} /></div>;
    $[21] = base;
    $[22] = isLoading;
    $[23] = selectedProduct;
    $[24] = tailored;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t12 || $[29] !== t13 || $[30] !== t9) {
    t14 = <div className="mini-pdp-drawer__product" data-testid="mini-pdp-product-data" data-base-loaded={t9} data-tailored-loaded={t10}>{t11}{t12}{t13}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== selectedStoreName) {
    t15 = selectedStoreName && <p className="mini-pdp-drawer__selected-store" data-testid="mini-pdp-selected-store">Selected store: {selectedStoreName}</p>;
    $[32] = selectedStoreName;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== onFindStoreClick) {
    t16 = <Button fullWidth={true} text="Find a store" data-testid="mini-pdp-btn-find-store" onClick={() => {
      onFindStoreClick?.();
      setIsStoreDrawerOpen(true);
    }} />;
    $[34] = onFindStoreClick;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== handleAddToCartClick) {
    t17 = <Button fullWidth={true} text="Added to cart" data-testid="mini-pdp-btn-added-to-cart" onClick={handleAddToCartClick} />;
    $[36] = handleAddToCartClick;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== onSameDayDeliveryClick) {
    t18 = <Button fullWidth={true} text="Same-day delivery" data-testid="mini-pdp-btn-sdd" onClick={onSameDayDeliveryClick} />;
    $[38] = onSameDayDeliveryClick;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  const t19 = !isOpen;
  let t20;
  if ($[40] !== close || $[41] !== t19) {
    t20 = <CurbsideInfoDetail showBackButton={true} forceClosed={t19} onCloseAll={close} />;
    $[40] = close;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t15 || $[44] !== t16 || $[45] !== t17 || $[46] !== t18 || $[47] !== t20) {
    t21 = <div className="mini-pdp-drawer__actions" data-testid="mini-pdp-drawer-actions">{t15}{t16}{t17}{t18}{t20}</div>;
    $[43] = t15;
    $[44] = t16;
    $[45] = t17;
    $[46] = t18;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t14 || $[50] !== t21) {
    t22 = <Drawer.Body className="mini-pdp-drawer__body" data-testid="mini-pdp-drawer-body">{t14}{t21}</Drawer.Body>;
    $[49] = t14;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== close || $[53] !== headingId || $[54] !== isOpen || $[55] !== t22 || $[56] !== t7 || $[57] !== t8) {
    t23 = <Drawer align="right" isActive={isOpen} onClose={close} data-testid="mini-pdp-drawer" className={t7} ariaLabelledBy={headingId} dismissible={true}>{t8}{t22}</Drawer>;
    $[52] = close;
    $[53] = headingId;
    $[54] = isOpen;
    $[55] = t22;
    $[56] = t7;
    $[57] = t8;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  const t24 = !isOpen;
  const t25 = selectedProduct?.deliveryMethods?.BOPIS?.purchaseQuantities?.min;
  const t26 = resolvedSku ? _temp5 : undefined;
  let t27;
  if ($[59] !== close || $[60] !== isStoreDrawerOpen || $[61] !== resolvedSku || $[62] !== t24 || $[63] !== t25 || $[64] !== t26) {
    t27 = <PDPStoreDrawer showBackButton={true} forceClosed={t24} onCloseAll={close} isActive={isStoreDrawerOpen} onOpenChange={setIsStoreDrawerOpen} sku={resolvedSku} drawerHeading="Pick up in store" toggleText="Only stores with item availability" className="pdp-page" minPurchaseQuantity={t25} filterFn={t26} />;
    $[59] = close;
    $[60] = isStoreDrawerOpen;
    $[61] = resolvedSku;
    $[62] = t24;
    $[63] = t25;
    $[64] = t26;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== cartConfirmDrawer || $[67] !== form || $[68] !== t23 || $[69] !== t27) {
    t28 = <FormProvider {...form}>{t23}{t27}{cartConfirmDrawer}</FormProvider>;
    $[66] = cartConfirmDrawer;
    $[67] = form;
    $[68] = t23;
    $[69] = t27;
    $[70] = t28;
  } else {
    t28 = $[70];
  }
  return t28;
}
function _temp5(stores) {
  return stores.filter(_temp4);
}
function _temp4(store) {
  return store.attributes?.bopisEnabled;
}
function _temp3(state_1) {
  return state_1.openWith;
}
function _temp2(state_0) {
  return state_0.close;
}
function _temp(state) {
  return state.isOpen;
}